<template>
<div>
    <router-view  v-if="!$auth.isLoading()"/>
    <div v-else>
        <div class="fill d-flex align-items-center justify-content-center max-height d-block" >
            <div class="text-center py-3">
                <div class="logo py-5 text-center">

                    <img alt="Loando Direct" src="./assets/loando-logo-dark.svg"/>
                </div>
                <div class="spinner-border" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <div>
                    Trwa uwierzytelnianie
                </div>
            </div>
        </div>
    </div>
    <div v-if="snackMessage" class="snackbar" :class="{show}">{{ snackMessage }}</div>
</div>

</template>
<script>
export default {
    provide() {
        return {
            snack: this.snack
        }
    },
    methods: {
        snack(message) {
            this.snackMessage = message;
            setTimeout(() => this.show = true, 100);
            setTimeout(() => this.show = false, 4000);
        }
    },
    data() {
        return {
            show: true,
            snackMessage: null
        }
    }
}
</script>